import React, { PropsWithChildren } from 'react';
import { useMediaQuery, usePageLoadTime } from 'hooks';
import { MenuCategories } from 'view/molecules/MenuCategories';
import { SimpleInterpolation } from 'styled-components';
import StaticAprilTreeSvg from 'static/banners/Staticapriltree.svg';
import SummerTreeSvg from 'static/banners/Summertree.svg';
import FallTreeSvg from 'static/banners/Falltree.svg';
import WinterTreeSvg from 'static/banners/Wintertree.svg';
import { getCurrentSeason } from 'utils';
import * as S from './Layout.styles';

type Props = PropsWithChildren<{
  customLayoutStyle?: SimpleInterpolation;
  hideLeftBlock?: boolean;
}>;

export const Layout = ({
  children,
  customLayoutStyle,
  hideLeftBlock,
}: Props) => {
  usePageLoadTime();
  const { notebook, desktop } = useMediaQuery();
  const isDesktop = notebook || desktop;

  const isLeftBlockShown = !hideLeftBlock && isDesktop;

  const season = getCurrentSeason();
  const seasonalTreeMap = {
    spring: StaticAprilTreeSvg,
    summer: SummerTreeSvg,
    fall: WinterTreeSvg,
    winter: FallTreeSvg,
  };
  const leftDecorSrc = seasonalTreeMap[season];

  return (
    <S.LayoutStyled customStyle={customLayoutStyle}>
      {isLeftBlockShown && (
        <S.LeftBlockStyled>
          <MenuCategories paddingNone />
        </S.LeftBlockStyled>
      )}

      <S.RightBlockStyled adjustWidthForLeftBlock={isLeftBlockShown}>
        <S.LeftDecorTree src={leftDecorSrc} alt='Seasonal Tree' />
        {children}
      </S.RightBlockStyled>
    </S.LayoutStyled>
  );
};
